import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { getClassName } from '../helpers';
import { EmbedFile } from '../templates';

export const Viewer = () => {
  const { files } = useSettings();

  return (
    <Component>
      {files.map((item) => (
        <EmbedFile key={item.id} item={item} />
      ))}
    </Component>
  );
};

const Component = styled.div.attrs({
  className: getClassName('viewer', 'component')
})`
  width: 100%;
  overflow: hidden;
`;
